import moment from "moment";
import { FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerListaRolUsuarioWeb(obj, combo = false, tag) {
    try {
        let data = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/rol-usuario-web/obtener-lista-rol-usuario-web",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            if (combo === false) {
                for (let i = 0; i < data.length; i++) {
                    data[i].fechaProceso = moment(data[i].fechaProceso).format("YYYY/MM/DD HH:mm");
                    data[i].habilitadoLabel = data[i].habilitado === 1 ? tag("column_habilitado") : tag("column_deshabilitado");
                }
            }
            if (combo === true) {
                data = data.map((item) => {
                    const codigo = item.codigo ? item.codigo : "";
                    const descripcion = item.descripcion ? item.descripcion : "";
                    return {
                        value: item.id,
                        label: codigo + " - " + descripcion,
                        esTransportadora: item.esTransportadora,
                        esCliente: item.esCliente,
                    };
                });
            }
        }
        return data;
    } catch (err) {
        console.log("obtenerListaRolUsuarioWeb err");
        console.log(err);
        return [];
    }
}

export async function crearRolUsuarioWeb(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/rol-usuario-web/crear-rol-usuario-web",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("crearRolUsuarioWeb err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarRolUsuarioWeb(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/rol-usuario-web/actualizar-rol-usuario-web",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarRolUsuarioWeb err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function deshabilitarRolUsuarioWeb(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/rol-usuario-web/deshabilitar-rol-usuario-web",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("deshabilitarRolUsuarioWeb err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function habilitarRolUsuarioWeb(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/rol-usuario-web/habilitar-rol-usuario-web",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("habilitarRolUsuarioWeb err");
        console.log(err);
        return { error: true, message: err };
    }
}